<template>
  <div v-if="clinic_config.enable_customer_levels" class="customer-level" :style="style" data-toggle="tooltip"
    :title="name">
    <img v-if="name != ''" :src="icon_url" :alt="name">
  </div>
</template>

<script>
export default {
  props: ['customer', 'size'],
  computed: {
    level() {
      if (!this.customer) {
        return null;
      }

      if (!this.customer.custom_fields) {
        return null;
      }

      return this.customer.custom_fields.customer_level || null;
    },
    icon_url() {
      return `/img/customer-level_${this.level}.svg`;
    },
    name() {
      if (!this.clinic_config || !this.clinic_config.customer_levels) {
        return '';
      }
      return this.clinic_config.customer_levels[this.level] || '';
    },
    style() {
      let ret = {
        width: this.size,
        height: this.size,
      };

      if (this.name == '') {
        ret.display = 'none';
      }

      return ret;
    },
    ...mapGetters(['clinic_config']),
  }
}
</script>

<style lang="scss">
.customer-level {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
